export class SystemPropertiesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSystemPropertiesInternal({ companyId }) {
    return this.#http.get(`/SystemProperties/internal/${companyId}`);
  }

  async getSystemProperties() {
    return this.#http.get('/SystemProperties');
  }

  async getSystemPropertyByPropertyName() {
    return this.#http.get('/SystemProperties');
  }

  async createSystemPropertiesInternal(body) {
    return this.#http.post('/SystemProperties/internal', body);
  }

  async createSystemProperties(body) {
    return this.#http.post('/SystemProperties', body);
  }

  async deleteSystemPropertiesInternal({ companyId, propName }) {
    return this.#http.delete(`/SystemProperties/internal/${companyId}/${propName}`);
  }

  async deleteSystemProperties({ propName }) {
    return this.#http.delete(`/SystemProperties/${propName}`);
  }

  async getPropertyDefinitions() {
    return this.#http.get('/SystemProperties/definitions/all');
  }

  async createPropertyDefinition(body) {
    return this.#http.post('/SystemProperties/definitions', body);
  }

  async updatePropertyDefinition({ id, ...body }) {
    return this.#http.put(`/SystemProperties/definitions/${id}`, body);
  }

  async deletePropertyDefinition({ id }) {
    return this.#http.delete(`/SystemProperties/definitions/${id}`);
  }

  async getAllPropertyDefinitions() {
    return this.#http.get('/SystemProperties/definitions/all', {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async getUserOverrides({ userId }) {
    return this.#http.get(`/SystemProperties/user-overrides/${userId}`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async setUserOverride({ userId, propertyName, value }) {
    return this.#http.put(
      `/SystemProperties/user-overrides/${userId}/${propertyName}`,
      { value },
      { skipResponseInterceptor: { forbiddenError: true } },
    );
  }

  async deleteUserOverride({ userId, propertyName }) {
    return this.#http.delete(`/SystemProperties/user-overrides/${userId}/${propertyName}`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async getUserOverridesInternal({ companyId, userId }) {
    return this.#http.get(`/SystemProperties/internal/${companyId}/user-overrides/${userId}`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async setUserOverrideInternal({ companyId, userId, propertyName, value }) {
    return this.#http.put(
      `/SystemProperties/internal/${companyId}/user-overrides/${userId}/${propertyName}`,
      { value },
      { skipResponseInterceptor: { forbiddenError: true } },
    );
  }

  async deleteUserOverrideInternal({ companyId, userId, propertyName }) {
    return this.#http.delete(
      `/SystemProperties/internal/${companyId}/user-overrides/${userId}/${propertyName}`,
      { skipResponseInterceptor: { forbiddenError: true } },
    );
  }
}
